<template>
  <div class="gf-field" :class="{focused: open}">
    <div class="select-box">
      <ul class="select-value" @click="toggleOpen" ref="selectValue">
        <li>
          <SelectDispPlain v-if="selectedOption==null" :option="{value: null, text: customValue?customValue:'(none)'}" mode="value" />
          <component :is="'select-disp-'+(type || 'plain')" v-else :option="selectedOption" mode="value" />
        </li>
      </ul>
      <div class="select-caret" @click="toggleOpen" ref="selectCaret" tabindex="0" @keyup.enter="toggleOpen">
        <i class="fa-solid fa-caret-down"></i>
      </div>
      <div class="select-list" v-if="open" ref="selectList">
        <ul>
          <li class="search">
            <input type="text" v-model="query" placeholder="search here" ref="selectSearch" @keyup.stop.prevent="handleKeyUp($event)" @keypress.stop="" @keydown.stop="" />
          </li>
          <li v-if="optional" :class="{selected: componentValue==null}" tabindex="0" @keyup="handleKeyUp($event, {value: null})">
            <SelectDispPlain :selected="componentValue==null" :option="{value: null, text: '(none)'}" mode="list" @click="doSelect(null)"  />
          </li>
          <li v-for="option in visibleOptions || []" tabindex="0" @keyup="handleKeyUp($event, option)" :class="{selected: componentValue==option.value}">
            <component :is="'select-disp-'+(type || 'plain')" :selected="componentValue==option.value" :option="option" mode="list" @click="doSelect(option.value)" />
          </li>
          <li tabindex="0" @keyup="handleKeyUp($event, {value: 'customValue'})">
            <SelectDispPlain :selected="componentValue==null" :option="{value: null, text: 'Custom: '+query}" mode="list" @click="doSelectCustom"  />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { componentMixin } from './FormCommon'

export default {
  props: ["placeholder", "options", "type", "optional", "customValue"],
  mixins: [componentMixin],
  data: ()=>({
    open: false,
    query: "",
  }),
  computed: {
    selectedOption() {
      return (this.options || []).find(opt=>opt.value==this.componentValue) || null;
    },
    visibleOptions() {
      return (this.options || []).filter(opt=>{
        return true;
      });
    },
  },
  watch: {
    open() {
      this.$nextTick(()=>{
        this.$refs.selectSearch && this.$refs.selectSearch.focus();
      });
    },
  },
  methods: {
    toggleOpen(type, $event) {
      this.open=!this.open;
    },
    handleKeyUp($event, option) {
      $event.stopPropagation();
      if (!option)
        option=this.visibleOptions[0] || {value: 'customValue'};
      if ($event.key=="Enter") {
        if (option=='customValue') {
          this.componentValue=null;
          this.$emit("update:customValue", this.query);
          this.query=null;
        } else {
          this.componentValue=option.value;
          this.$emit("update:customValue", null);
        }
        this.open=false;
      }
    },
    bodyClickListener($event) {
      if (!this.$refs.selectList) {
        this.open=false;
      } else {
        var el=$event.target;
        while(el) {
          if (el==this.$refs.selectList ||
              el==this.$refs.selectValue ||
              el==this.$refs.selectCaret)
            break;
          el=el.parentNode;
        }
        if (!el)
          this.open=false;
      }
    },
    doSelect(value) {
      this.open=false;
      this.componentValue=value;
      this.$emit("update:customValue", null);
    },
    doSelectCustom() {
      this.open=false;
      this.componentValue=null;
      this.$emit("update:customValue", this.query);
      this.query=null;
    },
  },
  mounted() {
    this.bodyClickListenerBound=this.bodyClickListener.bind(this);
    document.body.addEventListener("click", this.bodyClickListenerBound);
  },
  destroyed() {
    document.body.removeEventListener("click", this.bodyClickListenerBound);
  },
}
</script>
